type Props = {
    url: string,
    text: string
}
export function Link({ url, text }: Props) {
    return <a href={url} target="_blank" rel="noreferrer" className="text-[#c5b078ad] hover:bolder hover:underline">{ text }</a>
}